import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const AboutUsContent = ({ showHeroSection = true, showCTA = true }) => {
    return (
        <div>
            {/* Our Story Section */}
            <div className="py-8" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="px-4 lg:px-8">
                    <div className="grid align-items-center">
                        <div className="col-12 lg:col-6 pr-0 lg:pr-8">
                            <span className="text-primary font-semibold text-lg">OUR STORY</span>
                            <h2 className="text-5xl font-bold text-900 mt-3 mb-4">
                                Making Loans Easier & Faster
                            </h2>
                            <p className="text-lg text-600 line-height-3 mb-4">
                                Interestng is a Fintech ,It provides online loan comparison, customized loan documentation, loan application and loan processing 
                                which leads to ease of doing business.
                            </p>
                            <p className="text-lg text-600 line-height-3">
                                To enable loan originators with different bank products and process.
                            </p>
                        </div>
                        <div className="col-12 lg:col-6 mt-5 lg:mt-0">
                            <div className="relative">
                                <img 
                                    src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?w=800" 
                                    alt="Financial Services" 
                                    className="w-full border-round-xl shadow-4"
                                    style={{ maxHeight: '400px', objectFit: 'cover' }}
                                />
                                <div className="absolute bottom-0 left-0 bg-primary-500 text-white p-4 m-4 border-round-lg">
                                    <div className="text-3xl font-bold">10K+</div>
                                    <div className="text-sm">Happy Customers</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mission & Vision */}
            <div className="py-8 px-4 lg:px-8">
                <div className="grid">
                    <div className="col-12 lg:col-6 pr-0 lg:pr-3">
                        <Card className="h-full border-round-2xl shadow-4 overflow-hidden hover:shadow-8 transition-all transition-duration-300">
                            <div className="flex align-items-center mb-4">
                                <div className="bg-primary-100 p-3 border-round-xl mr-3">
                                    <i className="pi pi-eye text-primary text-3xl"></i>
                                </div>
                                <h2 className="text-3xl font-bold text-900 m-0">Our Vision</h2>
                            </div>
                            <p className="text-lg text-700 line-height-3 m-0">
                                Our vision is to give access to the loan consumers with different profiles with multiple options and to be successful 
                                in availing best suited loans. To reduce the cost of loans through loan portfolio management in the long run.
                            </p>
                        </Card>
                    </div>
                    
                    <div className="col-12 lg:col-6 pl-0 lg:pl-3 mt-4 lg:mt-0">
                        <Card className="h-full border-round-2xl shadow-4 overflow-hidden hover:shadow-8 transition-all transition-duration-300">
                            <div className="flex align-items-center mb-4">
                                <div className="bg-green-100 p-3 border-round-xl mr-3">
                                    <i className="pi pi-compass text-green-600 text-3xl"></i>
                                </div>
                                <h2 className="text-3xl font-bold text-900 m-0">Our Mission</h2>
                            </div>
                            <p className="text-lg text-700 line-height-3 m-0">
                                To enable loan originators with different bank products and processes, making lending easier and faster for everyone. 
                                We strive to create a seamless experience that benefits both lenders and borrowers through innovative technology solutions.
                            </p>
                        </Card>
                    </div>
                </div>
            </div>

            {/* Why Choose Us */}
            <div className="py-8" style={{ 
                background: 'linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)' 
            }}>
                <div className="px-4 lg:px-8">
                    <div className="text-center mb-6">
                        <span className="text-primary font-semibold text-lg">Why Interestng</span>
                        <h2 className="text-5xl font-bold text-900 mt-3">What Makes Us Different</h2>
                    </div>
                    
                    <div className="grid">
                        {/* Feature 1 */}
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="p-4 h-full">
                                <div className="text-center">
                                    <div className="bg-blue-50 inline-flex align-items-center justify-content-center border-round-xl mb-4" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-bolt text-blue-500 text-3xl"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-900 mb-3">Lightning Fast</h3>
                                    <p className="text-gray-600 line-height-2">
                                        Quick loan processing and instant comparisons. Get results in minutes, not days.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="p-4 h-full">
                                <div className="text-center">
                                    <div className="bg-green-50 inline-flex align-items-center justify-content-center border-round-xl mb-4" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-shield text-green-500 text-3xl"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-900 mb-3">Secured with SSL certificate</h3>
                                    <p className="text-gray-600 line-height-2">
                                        Your data is protected with enterprise-grade security standards.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 3 */}
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="p-4 h-full">
                                <div className="text-center">
                                    <div className="bg-orange-50 inline-flex align-items-center justify-content-center border-round-xl mb-4" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-chart-line text-orange-500 text-3xl"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-900 mb-3">Real-time Analytics</h3>
                                    <p className="text-gray-600 line-height-2">
                                        Track and monitor your loan applications with comprehensive dashboards.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Feature 4 */}
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="p-4 h-full">
                                <div className="text-center">
                                    <div className="bg-purple-50 inline-flex align-items-center justify-content-center border-round-xl mb-4" 
                                         style={{ width: '80px', height: '80px' }}>
                                        <i className="pi pi-users text-purple-500 text-3xl"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-900 mb-3">Expert Support</h3>
                                    <p className="text-gray-600 line-height-2">
                                        Dedicated team of experts to assist you at every step of your journey.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Stats Section */}
            <div className="py-8 px-4 lg:px-8" style={{ backgroundColor: '#1e1e2e' }}>
                <div className="grid text-center">
                    <div className="col-12 md:col-3">
                        <div className="p-4">
                            <h2 className="text-5xl font-bold text-primary mb-2">50+</h2>
                            <p className="text-gray-300 text-lg">Partner Banks</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-4">
                            <h2 className="text-5xl font-bold text-primary mb-2">10K+</h2>
                            <p className="text-gray-300 text-lg">Happy Customers</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-4">
                            <h2 className="text-5xl font-bold text-primary mb-2">₹100Cr+</h2>
                            <p className="text-gray-300 text-lg">Loans Processed</p>
                        </div>
                    </div>
                    <div className="col-12 md:col-3">
                        <div className="p-4">
                            <h2 className="text-5xl font-bold text-primary mb-2">99.9%</h2>
                            <p className="text-gray-300 text-lg">Uptime</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* CTA Section - Optional */}
            {showCTA && (
                <div className="py-8 px-4 lg:px-8 text-center" style={{ 
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
                }}>
                    <h2 className="text-4xl font-bold text-white mb-4">Ready to Transform Your Lending Experience?</h2>
                    <p className="text-xl text-white mb-6 opacity-90">
                        Join thousands of businesses that trust Interestng for their verification needs
                    </p>
                    <div className="flex gap-3 justify-content-center">
                        <Button 
                            label="Get Started Free" 
                            icon="pi pi-arrow-right" 
                            className="p-button-rounded p-button-lg bg-white text-primary-500 border-none font-bold px-5"
                            onClick={() => window.location.href = '/register'}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AboutUsContent;